import { types } from '../../../actions';

const initialState = {};

export default function byExpenseIdReducer(state = initialState, action) {
    switch (action.type) {
        case types.FETCH_EXPENSE_TRIGGERS_SUCCESS:
            return {
                ...state,
                ...action.payload.byExpenseId,
            };

        case types.DELETE_EXPENSE_TRIGGER_SUCCESS: {
            const { expenseId } = action.meta;

            if (state[expenseId]) {
                const nextState = { ...state };

                delete nextState[expenseId];

                return nextState;
            }

            return state;
        }

        case types.CREATE_EXPENSE_TRIGGER_SUCCESS:
        case types.FETCH_EXPENSE_TRIGGER_SUCCESS:
            return {
                ...state,
                [action.payload.expenseId]: action.meta.id,
            };

        default:
            return state;
    }
}
